export { default } from '@framework/tenant/config/creditflowresearch';
